module.exports = __webpack_public_path__ + "img/Mover_Side_Left.e7345bd2.svg";